import React, { useMemo } from 'react'
import UpvalueLeaderboardWidget from './UpvalueLeaderboardWidget'
import {
    extractLeaderboardEmbedConfig,
    LeaderboardEmbedConfig,
} from 'components/shared/LinkPreview'

interface LeaderboardMessageEmbedProps {
    className?: string
    config?: LeaderboardEmbedConfig
    url?: string
    onContentLayoutSettled?: () => void
    onShare?: () => void
    onJoin?: () => void
}

export default function LeaderboardMessageEmbed({
    className,
    config: embedConfig,
    onContentLayoutSettled,
    onJoin,
    onShare,
    url,
}: LeaderboardMessageEmbedProps) {
    const config = useMemo(
        () => embedConfig || (url ? extractLeaderboardEmbedConfig(url) : null),
        [embedConfig, url],
    )

    if (!config) return null

    return (
        <UpvalueLeaderboardWidget
            className={className}
            range="1d"
            date={config.date || undefined}
            embedded={true}
            onContentLayoutSettled={onContentLayoutSettled}
            onShare={onShare}
            onJoin={onJoin}
        />
    )
}
